import Colors from '@/constants/colors';

interface PageHeaderProps {
  title: string;
  logoSrc?: string;
}

export default function PageHeader({ title, logoSrc }: PageHeaderProps) {
  const titleStyle = logoSrc
    ? { ...styles.title, ...styles.titleWithLogo }
    : styles.title;

  return (
    <div style={styles.header}>
      <h1 style={titleStyle}>
        {logoSrc && (
          <img
            src={logoSrc}
            alt=""
            style={styles.logo}
            loading="eager"
            decoding="async"
          />
        )}
        {title}
      </h1>
    </div>
  );
}

const styles = {
  header: {
    padding: '24px 24px 16px 24px',
  } as React.CSSProperties,

  title: {
    fontSize: '32px',
    fontWeight: '700',
    color: Colors.text,
    margin: 0,
  } as React.CSSProperties,

  titleWithLogo: {
    display: 'flex',
    alignItems: 'center',
  } as React.CSSProperties,

  logo: {
    height: '36px',
    width: 'auto',
    marginRight: '2px',
    marginTop: '-8px',
  } as React.CSSProperties,
};
